// check that user age is over 18
(function () {
    const cookieName = 'ageRestrictionPassed';
    const restrictionsBlock = document.querySelector('.js-c-age-restrictions');
    if (!restrictionsBlock) return false;

    preventScroll();

    document.addEventListener('click', clickHandler);
    document.addEventListener('click', closeAllModals);
    window.addEventListener('modalClosed', preventScroll);

    function clickHandler(e) {
        const btn = e.target.closest('.js-c-age-restrictions-agree');
        if (!btn) return false;

        window.removeEventListener('modalClosed', preventScroll);
        setCookie(cookieName, '1', 365);
        removeScrollPrevent();
        setTimeout(() => {
            restrictionsBlock.remove();
        }, 500)
    }

    /**
     * Set cookie
     * @param {string} name - cookie name
     * @param {string} value - cookie value
     * @param {number} period - period in days
     */
    function setCookie(name, value, period) {
        const date = new Date();
        date.setTime(date.getTime() + (period*24*60*60*1000)); // days
        var expires = "expires=" + date.toUTCString();
        document.cookie = name + "=" + value + "; " + expires + "; path=/";
    }

    function closeAllModals(e) {
        const element = e.target.closest(`.js-c-age-restrictions`);
        if (!element) return false;

        new Modal().hideModalImmediately();
    }

    function preventScroll() {
        document.documentElement.classList.add('m-modal--shown');
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100vh';
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = `${window.innerWidth - document.documentElement.clientWidth}px`;
        document.body.style.height = '100vh';
    }

    function removeScrollPrevent() {
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.height = null;
        document.documentElement.classList.remove('m-modal--shown');
        document.documentElement.style.overflow = '';
        document.documentElement.style.height = null;
    }
}) ();